import styled from '@emotion/styled';
import { Typography, Button } from '@mgmresorts/mgm-ui';

export const StyledHeading = styled(Typography)<{ $hasPromoBanner?: boolean }>`
  ${({ theme, $hasPromoBanner }) => `
    color: ${theme.semantic.FgDefault};
    padding-top: ${$hasPromoBanner ? '0px' : `${theme.semantic.SpaceComponentL}px`};
    margin-top: ${theme.semantic.SpaceComponentXl}px;
    margin-bottom: ${$hasPromoBanner ? `${theme.semantic.SpaceComponentM}px` : `${theme.semantic.SpaceComponentL}px`};
    ${
      $hasPromoBanner &&
      `
        text-align: center;
        @media (max-width: 768px) {
          margin-top: ${theme.semantic.SpaceComponentL}px;
          padding-top: ${theme.semantic.SpaceComponentNone}px;
          font-size: ${theme.semantic.HeadingMedium2.fontSize}px;
          margin-bottom: ${theme.semantic.SpaceComponentM}px;
        }
      `
    }
  `}
`;

export const StyledInputContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledButton = styled(Button)<{ $hasPromoBanner?: boolean }>`
  ${({ theme, $hasPromoBanner }) => `
    margin-top: ${theme.semantic.SpaceComponentL}px;
    ${
      $hasPromoBanner &&
      `
        @media (max-width: 768px) {
          margin-top: ${theme.semantic.SpaceComponentM}px;
        }
      `
    }
  `}
`;

export const StyledSubTitle = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledFooterContainer = styled.div<{ $isMobile?: boolean }>`
  ${({ theme }) => `
    padding: 0px 0px ${theme.semantic.SpaceComponentM}px !important;
    flex-shrink: 0 !important;
    width: 100%;
    
  `}
  ${({ $isMobile }) => !$isMobile && `text-align: center;`}
 
  > * {
    padding: 0 16px !important;
  }
`;
